import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Avatar from '@vip-activity/ui/components/Avatar/Avatar.vue';
import env from '@tencent/vft-common/env';
import { initUserState } from '@vip-activity/business';
export default {
  props: {
    laiseeInfo: {
      type: Object,
      default: null
    },
    laiseeStatus: {
      type: Object,
      default: null
    }
  },
  methods: {
    openPacket: function openPacket() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var isLogin;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(env.isKidApp || _this.test)) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return initUserState();

              case 3:
                isLogin = _context.sent;

                if (isLogin) {
                  _this.$emit('openPacket');
                } else {
                  _this.loginService.openLogin();
                }

                return _context.abrupt("return");

              case 6:
                _this.openKidUrl(window.location.href);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  components: {
    Avatar: Avatar
  }
};